// JS for block-specific behavior only
console.log('res process steps block loaded');